// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3HCmw","colMaxWidth":"Table_colMaxWidth__3XCny"};